import { render, staticRenderFns } from "./ResourcesLog.vue?vue&type=template&id=47d2934d&"
import script from "./ResourcesLog.vue?vue&type=script&lang=js&"
export * from "./ResourcesLog.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesLog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47d2934d')) {
      api.createRecord('47d2934d', component.options)
    } else {
      api.reload('47d2934d', component.options)
    }
    module.hot.accept("./ResourcesLog.vue?vue&type=template&id=47d2934d&", function () {
      api.rerender('47d2934d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/reports/ResourcesLog.vue"
export default component.exports